<template>
    <div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.uzakDizin')}}</label>
            <div class="col">
                <div class="input-group mb-3">
                    <input type="text" v-model="value.Path" name="Path" class="form-control" />
                    <div class="input-group-append">
                        <button type="button" class="btn btn-secondary" @click="$emit('ftpLookupTargetSystem')">
                            {{translate('lookup')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {
    },
    props: ['value'],
    data(){
        return {

        }
    },
    methods: {
    }
}

</script>